import Option from '../types/Option';
import OptionGroup from '../types/OptionGroup';

const isOptionGroup = (option: Option | OptionGroup): option is OptionGroup =>
    'options' in option;

export default isOptionGroup;
